import Api from './Api';
import { store } from '../../store/store';
import { setCountries } from '../../store/actions/actions';

const DEFAULT_FILTER = {
  order: ['suggested DESC', 'name']
};

let countriesPromise = null;

const hasCountriesCached = () => {
  const countriesState = store.getState().countries;

  return Array.isArray(countriesState?.countries) && countriesState.countries.length > 0;
};

export const ensureCountriesLoaded = (filter = DEFAULT_FILTER) => {
  if (hasCountriesCached()) {
    return Promise.resolve(store.getState().countries.countries);
  }

  if (countriesPromise) return countriesPromise;

  const api = new Api();
  const appliedFilter = filter && Object.keys(filter).length > 0 ? filter : DEFAULT_FILTER;

  countriesPromise = api
    .getAsync('Countries', appliedFilter)
    .then((response) => {
      const data = Array.isArray(response.data) ? response.data : [];
      store.dispatch(setCountries(data));

      return data;
    })
    .finally(() => {
      countriesPromise = null;
    });

  return countriesPromise;
};
